<template>
    <div class="generator">
        <transition name="pattern-background-top" appear>
            <div v-if="showBackgroundPattern"
                 class="pattern-background pattern-background--top"
                 :class="patternBackgroundClass"
            ></div>
        </transition>
        <transition name="pattern-background-bottom" appear>
            <div v-if="showBackgroundPattern"
                 class="pattern-background pattern-background--bottom"
                 :class="patternBackgroundClass"
            >
            </div>
        </transition>
        <div class="generator__wrapper">
            <div class="generator__preview" :class="previewClasses">
                <app-device-preview
                        :currentPanel="currentPanel"
                        :wallpaper="wallpaper"
                ></app-device-preview>
            </div>

            <div class="generator__sidebar">
                <div class="generator__header">
                    <app-panel-header
                            :current-panel="currentPanel"
                            :panels="panels"
                    >
                    </app-panel-header>


                    <app-panel-drop-navigation
                            :current-panel="currentPanel"
                            :numberOfPanels="numberOfPanels"
                            :panels="panels"
                    ></app-panel-drop-navigation>
                </div>

                <template v-if="currentPanel < 3">
                    <div id="generator__panels" class="generator__panels" :class="panelClasses">
                        <transition name="panel-change"
                                    appear
                                    :appear-class="panelChangeEnterClass"
                                    :enter-class="panelChangeEnterClass"
                                    :enter-active-class="panelChangeEnterActiveClass"
                                    :leave-class="panelChangeLeaveClass"
                                    :leave-active-class="panelChangeLeaveActiveClass"
                        >
                            <keep-alive>
                                <compontent :is="panels[currentPanel].component"
                                            :patterns="patterns"
                                            :wallpaper="wallpaper"
                                >
                                </compontent>
                            </keep-alive>
                        </transition>
                    </div>
                </template>
            </div>

            <div class="generator__paging">
                {{ panelPaging }}
            </div>
        </div>
    </div>
</template>

<script>
    import DevicePreview from './preview/Device';
    import PanelHeader from './panels/Header';
    import PanelDropNavigation from './panels/DropNavigation';
    import PanelDevices from './panels/Devices';
    import PanelPatterns from './panels/Patterns';
    import PanelKudos from './panels/Kudos';

    export default {
        props: ['currentPanel', 'mobilePanel', 'numberOfPanels', 'panelChangeDirection'],
        components: {
            appDevicePreview: DevicePreview,
            appPanelDevices: PanelDevices,
            appPanelDropNavigation: PanelDropNavigation,
            appPanelHeader: PanelHeader,
            appPanelKudos: PanelKudos,
            appPanelPatterns: PanelPatterns,
        },
        data() {
            return {
                panels: [
                    {
                        name: 'Device',
                        label: 'Select Device',
                        component: 'app-panel-devices'
                    },
                    {
                        name: 'Muster',
                        label: 'Switch Pattern',
                        component: 'app-panel-patterns'
                    },
                    {
                        name: 'Kudos',
                        label: 'Switch Kudos',
                        component: 'app-panel-kudos'
                    }
                ],
                patterns: [
                    {
                        name: 'simquadrat',
                        colorToggle: true,
                        isBW: true,
                        isCorporate: false,
                        aspectRatio: 4.5435
                    },
                    {
                        name: 'basic',
                        colorToggle: true,
                        isBW: false,
                        isCorporate: false,
                        aspectRatio: 5.1902
                    },
                    {
                        name: 'team',
                        colorToggle: true,
                        isBW: false,
                        isCorporate: false,
                        aspectRatio: 5.1141
                    },
                    {
                        name: 'trunking',
                        colorToggle: true,
                        isBW: false,
                        isCorporate: false,
                        aspectRatio: 6.1630
                    },
                    {
                        name: 'io',
                        colorToggle: true,
                        isBW: false,
                        isCorporate: false,
                        aspectRatio: 4.0652
                    },
                    {
                        name: 'sipgate',
                        colorToggle: false,
                        isBW: true,
                        isCorporate: true,
                        aspectRatio: 3.3207
                    }
                ],
                wallpaper: {
                    device: {
                        "name": "Huawei P20",
                        "imageName": "Huawei_P20.svg",
                        "width": 1080,
                        "height": 2240,
                        "border": {
                            "top": 69,
                            "right": 63,
                            "bottom": 179,
                            "left": 53,
                            "camera": 80
                        }
                    },
                    height: 2240,
                    width: 1080,
                    pattern: null,
                    logo: true,
                    logoImage: null,
                    kudos: null
                },
                patternBackground: true,
                panelSwitchPosition: null,
            }
        },
        computed: {
            panelChangeEnterClass() {
                return 'panel-change-enter-dir-' + this.panelChangeDirection;
            },
            panelChangeEnterActiveClass() {
                return 'panel-change-enter-dir-' + this.panelChangeDirection + '-active';
            },
            panelChangeLeaveClass() {
                return 'panel-change-leave-dir-' + this.panelChangeDirection;
            },
            panelChangeLeaveActiveClass() {
                return 'panel-change-leave-dir-' + this.panelChangeDirection + '-active';
            },
            panelClasses() {
                if (this.mobilePanel == true) {
                    return 'is-active';
                } else {
                    return '';
                }
            },
            panelPaging() {
                return (this.currentPanel + 1) + '/' + (this.numberOfPanels - 1);
            },
            previewClasses() {
                if (this.mobilePanel == true) {
                    return 'is-blurred';
                } else {
                    return '';
                }
            },
            patternBackgroundClass() {

                let patternClass = this.wallpaper.pattern.name;
                if (this.wallpaper.pattern.isBW) {
                    patternClass += '-bw'
                }
                return patternClass;
            },
            showBackgroundPattern() {
                return (this.currentPanel >= 1 && this.patternBackground);
            }
        },
        methods: {
            toggleMobilePanel() {
                this.$emit('toggleMobilePanel');
            },
        }, created() {
            this.wallpaper.pattern = this.patterns[0];

            this.eventHub.$on('deviceSelected', data => {
                this.toggleMobilePanel();
            });

            this.eventHub.$on('patternSelected', data => {
                // Change pattern background
                let vm = this;
                vm.toggleMobilePanel();
                vm.patternBackground = false;
                setTimeout(function () {
                    vm.patternBackground = true;
                }, 250)
            });

            this.eventHub.$on('kudosSelected', data => {
                this.toggleMobilePanel();
            });
        }
    }
</script>

<style lang="scss">

    @import './../assets/scss/dimensions';

    .generator {
        &__paging {
            display: none;

            @media(min-width: 1024px) {
                display: block;
                position: absolute;
                bottom: $brand-size-x;
                right: $brand-size-x;
                font-family: PxGroteskRegular;
                font-size: 13px;
                color: #FFFFFF;
                letter-spacing: 0;
                padding: 8px 14px;
                transition: transform .2s linear;

                &:hover {
                    transform: rotate(360deg);
                }
            }
        }

        &__panels {
            background: rgba(0, 0, 0, 0.70);
            border: 1px solid #5E5E5E;
            border-radius: 7px;
            flex-direction: column;
            height: calc(100vh - 92px);
            left: 0;
            overflow: hidden;
            padding: 24px;
            position: fixed;
            top: 92px;
            width: 100vw;
            z-index: 15;
            transform: translateY(100%);
            transition: transform .5s ease-in-out;

            &.is-active {
                transform: translateY(0);

                .panel-switch__label {
                    opacity: 0;
                }
            }

            @media (min-width: 1024px) {
                background: none;
                border: 0;
                border-radius: 0;
                margin-top: 36px;
                max-width: 717px;
                padding: 0;
                position: static;
                transform: translateY(0) !important;
                width: 100%;
            }
        }

        &__panel {
            min-height: 100%;
            will-change: animation;
        }

        &__sidebar {
            @media (min-width: 1024px) {
                position: absolute;
                left: 50%;
                padding-right: 41px;
                width: 50%;
            }
        }

        &__preview {
            height: 100%;
            position: absolute;
            left: 0;
            transform: scale(1) translate(0, 0);
            transition: left .5s ease-out, filter .25s linear, transform .5s ease-out;
            width: 100%;

            &.is-blurred {
                filter: blur(5px);

                @media (min-width: 1024px) {
                    filter: none;
                }
            }

            @media (min-width: 1024px) {
                left: 0;
                position: absolute;
                transform: translateX(0) scale(1);
                width: calc(50% - 24px);
            }
        }

        &__wrapper {
            display: flex;
        }

    }

    .panel-content {
        h2 {
            font-family: PxGroteskRegular;
            font-size: 16px;
            margin: 15px 0 24px;
        }
    }

    .panel-change-enter-dir-next-active {
        animation: vueDummy .5s linear;

        .panel-animation {
            animation: slideToLeftIn .25s ease-out forwards;
        }

        .panel-content {
            animation: slideToLeftInWithHalfDelay .5s ease-out forwards;
        }
    }

    .panel-change-leave-dir-next-active {
        animation: slideToLeftOut .25s ease-out forwards;
    }

    .panel-change-enter-dir-prev-active {
        animation: vueDummy .5s linear;

        .panel-animation {
            animation: slideToRightIn .25s ease-out forwards;
        }

        .panel-content {
            animation: slideToRightInWithHalfDelay .5s ease-out forwards;
        }
    }

    .panel-change-leave-dir-prev-active {
        animation: slideToRightOut .25s ease-out forwards;
    }

    .pattern-background {
        background-repeat: no-repeat;
        background-size: contain;
        height: 50%;
        position: fixed;
        width: 50%;
        will-change: transform, opacity;
        z-index: -1;
    }

    $patterns: simquadrat basic team trunking io;

    .pattern-background--top {
        top: 0;
        right: 0;
        background-position: top right;
        height: 100%;
        width: 100%;

        @media(min-width: 768px) {
            height: 25%;
            width: 25%;
        }

        @each $pattern in $patterns {
            &.#{$pattern} {
                background-image: url('../assets/backgrounds/#{$pattern}-top.svg');
            }

            &.#{$pattern}-bw {
                background-image: url('../assets/backgrounds/#{$pattern}-top-bw.svg');
            }
        }

    }

    .pattern-background--bottom {
        display: none;
        bottom: 0;
        left: 0;
        background-position: bottom left;

        @media(min-width: 768px) {
            display: block;
            height: 25%;
            width: 25%;
        }

        @each $pattern in $patterns {
            &.#{$pattern} {
                background-image: url('../assets/backgrounds/#{$pattern}-bottom.svg');
            }

            &.#{$pattern}-bw {
                background-image: url('../assets/backgrounds/#{$pattern}-bottom-bw.svg');
            }
        }
    }

    .pattern-background--bottom.team,
    .pattern-background--bottom.team-bw {
        width: 50%;
        height: 50%;
        bottom: -10%;
        left: -3%;
        background-position: bottom left;
    }

    .pattern-background--top.team,
    .pattern-background--top.team-bw {
        width: 40%;
        height: 40%;
        top: -5%;
    }

    .pattern-background--bottom.trunking,
    .pattern-background--bottom.trunking-bw {
        width: 50%;
        height: 50%;
        left: -8%;
        bottom: -9%;
    }

    .pattern-background--top.trunking,
    .pattern-background--top.trunking-bw {
        width: 40%;
        height: 40%;
        right: -4%;
        top: -10%;
    }

    @keyframes patternTopIn {
        0% {
            opacity: 0;
            transform: skewX(20deg) translate3d(100%, -100%, 0);
        }
        100% {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes patternTopInAlternative {
        0% {
            opacity: 0;
            transform: skewX(20deg) translate3d(-100%, -100%, 0);
        }
        100% {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes patternTopOut {
        0% {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
        100% {
            opacity: 0;
            transform: skewX(20deg) translate3d(100%, -100%, 0);
        }
    }

    @keyframes patternTopOutAlternative {
        0% {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
        100% {
            opacity: 0;
            transform: skewX(20deg) translate3d(-100%, -100%, 0);
        }
    }

    .pattern-background-top-enter-active {
        animation: vueDummy .25s linear;

        &.simquadrat,
        &.simquadrat-bw,
        &.basic,
        &.basic-bw,
        &.io,
        &.io-bw,
        &.team,
        &.team-bw,
        &.trunking,
        &.trunking-bw {
            animation: patternTopIn .25s ease-out forwards;
        }
    }

    .pattern-background-top-leave-active {
        animation: vueDummy .25s linear;

        &.simquadrat,
        &.simquadrat-bw,
        &.basic,
        &.basic-bw,
        &.io,
        &.io-bw, &.team,
        &.team-bw,
        &.trunking,
        &.trunking-bw {
            animation: patternTopOut .25s ease-out forwards;
        }
    }

    @keyframes patternBottomIn {
        0% {
            opacity: 0;
            transform: skewX(20deg) translate3d(-100%, 100%, 0);
        }
        100% {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes patternBottomInAlternative {
        0% {
            opacity: 0;
            transform: skewX(20deg) translate3d(100%, 100%, 0);
        }
        100% {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes patternBottomOut {
        0% {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
        100% {
            opacity: 0;
            transform: skewX(20deg) translate3d(-100%, 100%, 0);
        }
    }

    @keyframes patternBottomOutAlternative {
        0% {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
        100% {
            opacity: 0;
            transform: skewX(20deg) translate3d(100%, 100%, 0);
        }
    }

    .pattern-background-bottom-enter-active {
        animation: vueDummy .25s linear;

        &.simquadrat,
        &.simquadrat-bw,
        &.basic,
        &.basic-bw,
        &.io,
        &.io-bw,
        &.team,
        &.team-bw,
        &.trunking,
        &.trunking-bw {
            animation: patternBottomIn .25s ease-out forwards;
        }
    }

    .pattern-background-bottom-leave-active {
        animation: vueDummy .25s linear;

        &.simquadrat,
        &.simquadrat-bw,
        &.basic,
        &.basic-bw,
        &.io,
        &.io-bw,
        &.team,
        &.team-bw,
        &.trunking,
        &.trunking-bw {
            animation: patternBottomOut .25s ease-out forwards;
        }
    }

    // Final page
    .is-on-final {
        #device-interaction-area {
            visibility: hidden;
        }

        .generator__preview {
            transform: scale(0.82) translate(0, 27px);
            transition: filter .6s linear, transform .5s ease-out;

            @media(min-width: 1024px) {
                position: absolute;
                transform: translateX(calc(50% + 20px)) scale(.8);
            }
        }

        .device__wrapper {
            height: auto;
        }

        .preview__wrapper {
            height: 100% !important;
            margin: 0 !important;
            padding: 24px;
            position: relative;
        }

        #device-border-image {
            filter: drop-shadow(0 0 10px rgba(0, 0, 0, .6));
        }

        #device-border-canvas.is-custom-width {
            box-shadow: 1px 1px 10px #000;
        }

    }

</style>


// WEBPACK FOOTER //
// src/components/Generator.vue